import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    .onboarding-email-title {
      margin: 0 0 8px;
      text-align: center;
    }

    .images-container {
      margin: 16px 0;
      height: 268px;
      width: 100%;
      background-color: transparent;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
    }

    .content {
      margin-top: 180px;
    }

    .email-disclaimer {
      text-align: center;
      margin: 12px 0 0;
    }

    .email-input-container {
      max-width: 372px;
      padding: 0 16px;
      width: 100%;
      margin: 16px auto 0;
    }

    .email-protection {
      margin: 16px auto;
      padding: 0 16px;
      max-width: 372px;
    }
  }
`;

export const Image = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  z-index: -1;
  filter: blur(8px);
  transform: scale(1.05);
`;
